import { doc } from "firebase/firestore";
import { getDb } from "@/firebase";

/**
 * Build a Firestore DocumentReference for an exercise.
 * Prefer existing ref path/parent when the exercise is already a DocumentReference
 * (e.g. after loading a preset) — isReactNativeExercise is often missing on refs.
 */
export function resolveExerciseDocumentRef(exercise) {
  if (!exercise) return null;

  const id =
    (typeof exercise.id === "string" && exercise.id) ||
    (typeof exercise.path === "string" &&
      exercise.path.includes("/") &&
      exercise.path.split("/").pop()) ||
    null;

  if (!id) return null;

  let collectionName = "excercisesNew";

  if (exercise.isReactNativeExercise === false) {
    collectionName = "excercises";
  } else if (typeof exercise.path === "string" && exercise.path.includes("/")) {
    collectionName = exercise.path.split("/")[0];
  } else if (exercise.parent && exercise.parent.id) {
    collectionName = exercise.parent.id;
  } else if (exercise.isReactNativeExercise === true) {
    collectionName = "excercisesNew";
  }

  return doc(getDb(), collectionName, id);
}
